import { ValTest } from './type'

export default function test(
    key: any,
    value: any,
    catch_error: (key: string, message: string) => any
): ValTest<any> {
    function isEmpty(message: string) {
        if (
            value === '' ||
            value === null ||
            value === undefined ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' &&
                !(value instanceof File) &&
                Object.values(value).length === 0)
        ) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function number(message: string) {
        const parsed = parseInt(value) || null
        if (!Number.isInteger(parsed)) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function minLength(length: number, message: string) {
        if (typeof value === 'string' && value.length < length) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function maxLength(length: number, message: string) {
        if (typeof value === 'string' && value.length > length) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function isFalse(message: string) {
        if (value === false) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function isTrue(message: string) {
        if (value === true) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function condition(expect: (value: any) => string | void) {
        const message = expect(value)
        if (message) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function email(message: string) {
        const regex = /\S+@\S+\.\S+/
        if (!regex.test(value)) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function isGreater(valTest: number, message: string) {
        if (value > valTest) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    function isMinor(valTest: number, message: string) {
        if (value < valTest) {
            catch_error(key, message)
        }
        return test(key, value, catch_error)
    }

    return {
        isEmpty,
        number,
        minLength,
        maxLength,
        isFalse,
        isTrue,
        condition,
        email,
        isGreater,
        isMinor
    }
}
